import React from "react";
import { View, StyleSheet } from "react-native";

import CTAButton from "../../../Components/CTAButton";
import GlobalStyles from "../../../../Resources/Styles";
import SearchBar from "../../../Components/SearchBar";

const styles = StyleSheet.create({
  toolbar: {
    marginBottom: 8,
    maxWidth: "45%",
  },
});

const BrowserToolbar = ({ searchTerm, onSearchChange, onOpenAddBlock }) => (
  <View style={[GlobalStyles.HStack, styles.toolbar]}>
    <SearchBar
      text={searchTerm}
      onChangeText={onSearchChange}
      placeholder="searchBlock-string"
      autoFocusOnDesktop={true}
    />
    <CTAButton
      plus={true}
      text="newBlock-string"
      action={onOpenAddBlock}
      disabled={false}
    />
  </View>
);

export default BrowserToolbar;
